/**
 * Created by LIDA1FH on 05/11/2016.
 */
module.exports = function(bootstrap) {
    bootstrap.run(['$rootScope', function($rootScope) {
        $rootScope.sidebar = {};
    }]);

    bootstrap.directive('clientSideBar', ["modal", "navigation", "brand", "services", "session", "$state", function(modal, navigation, brand, services, session, $state) {
        return {
            replace: true,
            template: require('directives/hmhs/clientSideBar.html'),

            link: function(scope) {
                var setActive = function(link) {
                    for (var z in scope.sidebar.links) {
                        if (scope.sidebar.links[z].state === link.state) {
                            link.active = true;
                        }else if(scope.sidebar.links[z].state.substring(0, scope.sidebar.links[z].state.indexOf('(')) === link.state){
                            link.active = true;
                        } else {
                            scope.sidebar.links[z].active =false;
                        }
                    }

                    return link;

                };
                var linkFromState = function(state) {
                    for (var z in scope.sidebar.links) {
                        if (scope.sidebar.links[z].state === state) {
                            return scope.sidebar.links[z];
                        }else if(scope.sidebar.links[z].state.substring(0, scope.sidebar.links[z].state.indexOf('(')) === state){
                            return scope.sidebar.links[z];
                        }
                    }
                };
                var link = linkFromState($state.current.name);
                if (link) {
                    setActive(link);
                }

                else {
                    // No link found.  Select 1st link.  This needs changed later to be an option rather than the default behaviour
                    setActive(scope.sidebar.links && scope.sidebar.links[0]);
                }
                scope.sidebar.setActive = function (link) {
                    setActive(link);
                };

                scope.$watch('sidebar.links',function(){
                    var link = linkFromState($state.current.name);
                    if (link) {
                        setActive(link);
                    }

                    else {
                        // No link found.  Select 1st link.  This needs changed later to be an option rather than the default behaviour
                        setActive(scope.sidebar.links && scope.sidebar.links[0]);
                    }
                });
            }
        };
    }]);
};